import { MdCalendarToday, MdOutlineAccountBalanceWallet, MdOutlineGroup } from 'react-icons/md';
import { TbHome } from 'react-icons/tb';
import { Link } from 'react-router-dom';

export default function BottomNav() {
  return (
    <div className="w-full fixed bottom-0 left-0 bg-white flex items-center justify-between py-4 px-7 border-2 border-neutralBlue2 z-50">
      <Link to={'/dashboard'}>
        <TbHome className="text-xl" />
      </Link>
      <Link to={'/students'}>
        <MdOutlineGroup className="text-xl" />
      </Link>
      <Link to={'/calendar'}>
        <MdCalendarToday className="text-xl" />
      </Link>
      <Link to={'/earnings'}>
        <MdOutlineAccountBalanceWallet className="text-xl" />
      </Link>
    </div>
  );
}
